<template>
    <div>
        <h3 class="mt-0">
            {{ $l10n.__('Informations de paiement') }}
        </h3>

        <el-checkbox-group v-model="payment">
            <div class="form-group">
                <el-checkbox label="delay">{{
                    $l10n.__('Afficher le délai de règlement')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="means">{{
                    $l10n.__('Afficher les moyens de règlements')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="deadline">{{
                    $l10n.__('Afficher la date limite de règlement')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="deposit">{{
                    $l10n.__('Afficher le détail de l‘acompte')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <div v-if="hasOnlinePayment">
            <h3>
                {{ $l10n.__('Modules de paiement en ligne') }}
            </h3>

            <div class="alert alert-info">
                {{
                    $l10n.__(
                        'Choisissez les modules de paiement en ligne que vous voulez activer par défaut sur vos documents.',
                    )
                }}
            </div>

            <el-checkbox-group v-model="onlinePayment">
                <div v-for="key in availableOnlinePayment" :key="key" class="form-group">
                    <el-checkbox :label="key">{{ getLabelForOnlinePayment(key) }}</el-checkbox>
                </div>
            </el-checkbox-group>
        </div>

        <div v-if="hasDirectDebit">
            <h3>
                {{ $l10n.__('Modules de prélèvement') }}
            </h3>

            <div class="alert alert-info">
                {{
                    $l10n.__(
                        'Choisissez le module de prélèvement automatique que vous voulez activer par défaut sur vos documents.',
                    )
                }}
            </div>

            <el-radio-group v-model="directDebit" class="sale-doc-payment-pref__direct-debit-group">
                <div v-for="key in availableDirectPayment" :key="key" class="form-group">
                    <el-radio :label="key">{{ getLabelForDirectPayment(key) }}</el-radio>
                </div>
                <el-radio label="">{{
                    $l10n.__('Ne pas activer de module de prélèvements par défaut')
                }}</el-radio>
            </el-radio-group>
        </div>

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
import Feature from 'Services/Feature';

export default {
    props: {
        defaultPayment: {
            type: Array,
            required: true,
        },
        defaultOnlinePayment: {
            type: Array,
            required: true,
        },
        defaultDirectDebit: {
            type: String,
            required: true,
        },
        availableOnlinePayment: {
            type: Array,
            required: true,
        },
        availableDirectPayment: {
            type: Array,
            required: true,
        },
        docPrefsId: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            payment: this.defaultPayment,
            onlinePayment: this.defaultOnlinePayment,
            directDebit: this.defaultDirectDebit,
            hasOnlinePayment: this.availableOnlinePayment.length > 0 && (Feature.isEnabled('quickpay-settings-page') === false),
            hasDirectDebit: this.availableDirectPayment.length > 0 && (Feature.isEnabled('quickpay-settings-page') === false),
            allPayments: {
                paypal: 'PayPal',
                stripe: 'Stripe',
                atos: 'Atos',
                adyen: 'Adyen',
                gocardless: 'Gocardless',
                stancer: 'Stancer',
            },
        };
    },
    methods: {
        getLabelForOnlinePayment: function (payment) {
            const paymentName = this.allPayments[payment];
            return this.$l10n.__('Activer par défaut le paiement via %s', paymentName);
        },
        getLabelForDirectPayment: function (payment) {
            const paymentName = this.allPayments[payment];
            return this.$l10n.__('Activer par défaut les prélèvements via %s', paymentName);
        },
        save: function () {
            const options = {
                onlinePayment: this.onlinePayment,
                directDebit: this.directDebit,
                payment: this.payment,
            };

            this.$ajax.put(
                `/rest/documents/payment-preferences/${this.docPrefsId}`,
                {},
                options,
                (data) => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    const errors = {};
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
<style scoped lang="scss">
.sale-doc-payment-pref {
    &__direct-debit-group {
        flex-direction: column;
        gap: var(--spacing-0);
        padding: var(--spacing-0) 0 0;
    }
}
</style>
